import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Hero from '@/pages/home/components/Hero';
import CompanyIntro from '@/pages/home/components/CompanyIntro';
import WhyUs from '@/pages/home/components/WhyUs';
import Capabilities from '@/pages/home/components/Capabilities';
import ProductPortfolio from '@/pages/home/components/ProductPortfolio';
import SupplyChain from '@/pages/home/components/SupplyChain';
import ValueAddedServices from '@/pages/home/components/ValueAddedServices';
import QualityAssurance from '@/pages/home/components/QualityAssurance';
import Compliance from '@/pages/home/components/Compliance';
import Sustainability from '@/pages/home/components/Sustainability';
import BuyersMarkets from '@/pages/home/components/BuyersMarkets';
import Leadership from '@/pages/home/components/Leadership';
import FactoryGallery from '@/pages/home/components/FactoryGallery';
import NewsInsights from '@/pages/home/components/NewsInsights';
import ContactSection from '@/pages/home/components/ContactSection';
import Footer from '@/pages/home/components/Footer';
import FloatingActions from '@/pages/home/components/FloatingActions';
import { useScrollAnimation } from '@/hooks/useScroll';
import SisterConcernsRow from '@/pages/home/components/SisterConcernsRow';

export default function Home() {
  useScrollAnimation();
  const location = useLocation();

  useEffect(() => {
    const state = location.state as { scrollTo?: string } | null;
    if (state?.scrollTo) {
      setTimeout(() => {
        const el = document.getElementById(state.scrollTo!);
        if (el) {
          const navHeight = 80;
          const y = el.getBoundingClientRect().top + window.scrollY - navHeight;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 300);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <main className="relative">
      <Navbar />
      <Hero />
      <CompanyIntro />
      <WhyUs />
      <Capabilities />
      <SisterConcernsRow />
      <ProductPortfolio />
      <SupplyChain />
      <ValueAddedServices />
      <QualityAssurance />
      <Compliance />
      <Sustainability />
      <BuyersMarkets />
      <Leadership />
      <FactoryGallery />
      <NewsInsights />
      <ContactSection />
      <Footer />
      <FloatingActions />
    </main>
  );
}